import { ILaneHistory } from 'types/carrier'
import { ITableCellProps } from 'transfix-ui'
import formatCurrency from 'utils/formatCurrency'
import { getTimeAgoShort } from 'utils/formatDatetime'

interface IColumn {
  label: string
  formatter: (lane: ILaneHistory) => string | number
  cellType?: ITableCellProps['type']
}

export const columns: IColumn[] = [
  {
    label: 'Lane',
    formatter: ({ deliveryCity, deliveryStateCode, pickupCity, pickupStateCode }) =>
      `${pickupCity}, ${pickupStateCode} – ${deliveryCity}, ${deliveryStateCode}`,
  },
  {
    label: 'Equipment',
    formatter: ({ equipmentName }) => equipmentName,
  },
  {
    label: 'Shipments',
    formatter: ({ shipmentCount }) => shipmentCount,
    cellType: 'number',
  },
  {
    label: 'Last Rate',
    formatter: ({ lastRate }) => formatCurrency(lastRate),
    cellType: 'number',
  },
  {
    label: 'Last Ran',
    formatter: ({ lastAssignedDate }) => getTimeAgoShort(lastAssignedDate),
  },
  {
    label: 'Last Dispatcher',
    formatter: ({ lastDispatcher }) => lastDispatcher,
  },
]
